// Global elements and application settings

// Simplified i18n helper
const i18n = require('common/hbs-helpers/__')
const axios = require('axios')
const {sleep} = require('common/helpers/async-tools')

const appVersion = 'v' + (require('../../../../package.json').version)


const state = {
   appTitle: i18n('label:app title'),
   appSubtitle: null,
   appVersion,
   breadcrumbs: [{
         title: i18n('label:home'),
         url: 'http://www.murdoch.edu.au/'
      },
      {
         title: i18n('label:app title'),
         path: '/'
      }
   ],
   pageBreadcrumbs: [],
   // Copy of the current URL, set by the Router, for use in things like the Login/Logout URLs
   thisUrl: null,
   baseUrl: '',
   pageData: {},
   menu: {},
   authUpdating: null,
   authUser: {},
   authUserStatus: 'unknown',
   auth: {},
   error: null,
   chunksUpdate: null,
   chunks: {},
   slideOut: {
      opened: false,
      locked: false,
      component: null,
      componentProperties: null
   },
}

const getters = {
   //returns the application title
   getBaseUrl: state => {
      return BaseURL;
   },
   //returns the application title
   getTitle: state => {
      return state.appTitle;
   },
   //returns the application sub title
   getSubTitle: state => {
      return state.appSubTitle;
   },
   //returns the application sub title
   getAppVersion: state => {
      return state.appVersion;
   },
   loginUrl: state => {
      // console.log('Getter global/loginUrl', state.auth)
      // Base URL based on Window full URL
      let loginUrl = new URL(window.location.toString().replace(/\?.*/, ''))
      // Change the Path to match the Login Path
      loginUrl.pathname = (state.auth && state.auth.loginUrl || '').replace(/\?.*/, '')
      // Change the "from" to match our Destination
      loginUrl.searchParams.set('from', state.thisUrl)
      return state.auth && loginUrl.toString()
   },
   logoutUrl: state => {
      // console.log('Getter global/loginUrl', state.auth)
      // Base URL based on Window full URL
      let logoutUrl = new URL(window.location.toString().replace(/\?.*/, ''))
      // Change the Path to match the Login Path
      logoutUrl.pathname = (state.auth && state.auth.logoutUrl || '').replace(/\?.*/, '')
      // Change the "from" to match our Destination
      logoutUrl.searchParams.set('from', state.thisUrl)
      return state.auth && logoutUrl.toString()
   },
   baseFullUrl: state => {
      let url = new URL(window.location.toString().replace(/\?.*/, ''))
      // Change the Path to match the base path
      url.pathname = state.baseUrl
      return url
   },
   isAuthenticated: state => {
      return state.authUser && state.authUserStatus == 'ok'
   },
   isReviewer: state => state.authUser && state.authUserStatus == 'ok' && state.authUser.profile?.reviewer,
   breadcrumbs: state => {
      return [...state.breadcrumbs, ...(state.pageBreadcrumbs || [])]
   },
}

const mutations = {
   SET_CHUNKS(state, chunks) {
      state.chunks = chunks
      state.chunksUpdate = true
   },
   setAuthUpdating(state) {
      state.authUpdating = true
      // state.authUserStatus = 'updating'
   },
   clearAuthUpdating(state) {
      state.authUpdating = false
   },
   setAuthUser(state, user) {
      state.authUser = user
      state.authUserStatus = user.username ? 'ok' : 'fail'
   },
   setAuth(state, auth) {
      state.auth = {}
      Object.keys(auth).forEach(k => {
         // Convert "login-url" to "loginUrl"
         state.auth[k.replace(/-(.)/g, g => g[1].toUpperCase())] = auth[k]
      })
      // console.log('auth', state.auth)
      // TODO: Replace "from" parameter on URLs with page URL (not API URL)
   },
   // General Error message triggered from any component.
   setError(state, error) {
      state.error = error
   },
   // Clear any error message. When do we clear this? On any success?
   clearError(state) {
      state.error = null
   },
   // Called by the Router, for use in things like the Login/Logout URLs
   setThisUrl(state, thisUrl) {
      state.thisUrl = thisUrl
   },
   // Called on Vue Init, to store the base URL rather than using literal Global BaseURL
   setBaseUrl(state, baseUrl) {
      state.baseUrl = baseUrl
   },
   // Called on Vue Init, to set optional Page Data - used by server-side Error page
   setPageData(state, data) {
      // console.log('Set Page Data', data)
      state.pageData = data
   },
   setMenu(state, menu) {
      // console.log({menu})
      state.menu = menu || {}
   },
   setPageBreadcrumbs(state, data) {
      state.pageBreadcrumbs = Array.isArray(data) ? data : [data]
   },
   clearPageBreadcrumbs(state) {
      state.pageBreadcrumbs = []
   },
   updateBreadcrumbs(state) {
      // Convert "path" param to full "url"
      state.breadcrumbs.forEach((item) => {
         if (!item.url && item.path != null) {
            // if (item.path.match(/^\//))
            //    item.url = item.path
            // else
            item.url = BaseURL + item.path
         }
      })
   },
   // this will set the slideout opened state to true, and set the component and its properties too
   openSlideOut(state, {
      component,
      componentProperties
   }) {
      state.slideOut.opened = true;
      state.slideOut.component = component;
      state.slideOut.componentProperties = componentProperties;
   },
   // this will communicate the state of the slideout, locking the slideout during loading events.
   lockSlideOut(state, locked) {
      state.slideOut.locked = locked;
   },
   // this will set the slideout opened state to true, and set the component and its properties to null
   closeSlideOut(state) {
      if (!state.slideOut.locked)
      {
         state.slideOut.opened = false;
         state.slideOut.component = null;
         state.slideOut.componentProperties = null;
      }
   }
}

const actions = {
   fetchChunks({
      state,
      commit,
      rootState,
      rootGetters
   }) {
      if (!state.chunksUpdate) {
         // console.log({BaseURL})
         axios.get(BaseURL + '/api/data/chunks')
            .then(response => {
               commit('SET_CHUNKS', response.data)
            })
      }
   },
   updateBreadcrumbs({
      state,
      commit
   }) {
      commit('updateBreadcrumbs')
   },
   fetchMenu({
      commit
   }) {
      axios.get(BaseURL + '/api/data/menu')
         .then(response => {
            commit('setMenu', response.data)
         })
   },
   fetchAuthUser: async function ({
      state,
      commit,
      rootState,
      rootGetters
   }) {
      let response
      commit('setAuthUpdating')
      try {
         if (!state.auth || !state.auth.url) {
            response = await axios.get(BaseURL + '/api/data/auth')
            commit('setAuth', response.data)
         }
         response = await axios.get(BaseURL + '/api/data/authUser')
         // console.log('authUser', response.data && response.data.username)
         commit('clearAuthUpdating')
         commit('setAuthUser', response.data)
      } catch (err) {
         let error = err.response && err.response.data && err.response.data.error || err.message
         commit('clearAuthUpdating')
         commit('setError', error)
      }
   },
   setAuthUser: function ({state, commit}, user) {
      commit('setAuthUser', user)
   },
   clearAuthSession: async function({state, commit}) {
      if (!state.auth?.url) return // No auth info - shouldn't need to clear a session now
      commit('setAuthUser', {})
      try {
         await axios.get(state.auth.url + '/clear')
      } catch (err) {
         console.log('Error clearing auth session', err, err.response, err.data)
      }
   },
   reauthenticateUser: async function ({state, commit, dispatch, getters}) {
      // Clear Authenticated User from our State
      console.log('Reauthenticate!')
      commit('setAuthUpdating')
      await sleep(50)
      let url = getters.loginUrl

      await dispatch('clearAuthSession')
      console.log('Redirect dbg', this.auth, this.loginUrl, window.location.toString().replace(/\?.*/, ''), url)
      window.location.assign(url)
   }
}

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}
